"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetCompletedLiquidityEpochsRequestSchema = exports.GetCurrentLiquidityEpochResponseSchema = exports.GetCurrentLiquidityEpochRequestSchema = exports.GetExplorePoolSummaryResponseSchema = exports.GetExplorePoolSummaryRequestSchema = exports.GetExploreTokenSummaryResponseSchema = exports.GetExploreTokenSummaryRequestSchema = exports.UpdateTransactionResponseSchema = exports.UpdateTransactionRequestSchema = exports.RegisterTransactionResponseSchema = exports.RegisterTransactionRequestSchema = exports.SynchronizeTransactionResponseSchema = exports.GetExploreTokenGraphResponseSchema = exports.GetExploreTokenGraphRequestSchema = exports.GetExploreTVLGraphResponseSchema = exports.GetExploreTVLGraphRequestSchema = exports.GetExploreVolumeGraphResponseSchema = exports.GetExploreVolumeGraphRequestSchema = exports.GetExploreGroupedTransactionsResponseSchema = exports.GetExploreGroupedTransactionsRequestSchema = exports.GetExploreTransactionsResponseSchema = exports.GetExploreTransactionsRequestSchema = exports.GetExploreTokensResponseSchema = exports.GetExploreTokensRequestSchema = exports.GetExplorePoolsResponseSchema = exports.GetExplorePoolsRequestSchema = exports.GetChartRWStakingAPRResponseSchema = exports.GetChartRWStakingAPRRequestSchema = exports.GetChartRWStakingResponseSchema = exports.GetChartRWStakingRequestSchema = exports.GetChartRWRewardsResponseSchema = exports.GetChartRWRewardsRequestSchema = exports.GetChartRWFarmingAPRResponseSchema = exports.GetChartRWFarmingAPRRequestSchema = exports.GetChartRWFarmingResponseSchema = exports.GetChartRWFarmingRequestSchema = exports.GetChartLQStakingResponseSchema = exports.GetChartLQStakingRequestSchema = exports.GetChartLQLiquidityPoolResponseSchema = exports.GetChartLQLiquidityPoolRequestSchema = exports.GetChartLQFarmingResponseSchema = exports.GetChartLQFarmingRequestSchema = exports.GetChartLQCirculatingSupplyResponseSchema = exports.GetChartLQCirculatingSupplyRequestSchema = exports.GetChartTVLResponseSchema = exports.GetChartTVLRequestSchema = exports.GetChartMainTokenPriceResponseSchema = exports.GetChartMainTokenPriceRequestSchema = exports.GetChartCommonRequestSchema = exports.GetApplicationInfoResponseSchema = void 0;
exports.GetUserVoteEpochRewardsResponseSchema = exports.GetUserVoteEpochRewardsRequestSchema = exports.GetCompletedVoteEpochsPoolStatsResponseSchema = exports.GetCompletedVoteEpochsPoolStatsRequestSchema = exports.GetCurrentVoteEpochPoolStatsResponseSchema = exports.GetUserPoolStatsResponseSchema = exports.GetUserPoolStatsRequestSchema = exports.GetUserRewardsResponseSchema = exports.GetUserRewardsRequestSchema = exports.GetUserBalancesResponseSchema = exports.GetUserBalancesRequestSchema = exports.GetUserAllowancesResponseSchema = exports.GetUserAllowancesRequestSchema = exports.GetUserEpochRewardsResponseSchema = exports.GetUserEpochRewardsRequestSchema = exports.GetUserSyntheticDepositsResponseSchema = exports.GetUserSyntheticDepositsRequestSchema = exports.GetHistoricalSyntheticStatsResponseSchema = exports.GetHistoricalSyntheticStatsRequestSchema = exports.GetCurrentEpochResponseSchema = exports.GetCurrentEpochRequestSchema = exports.GetCompletedEpochsRequestSchema = exports.GetProjectSyntheticStatsResponseSchema = exports.GetUserSwapPathResponseSchema = exports.GetUserSwapPathRequestSchema = exports.GetDEXStatsResponseSchema = exports.GetHistoricalAggregatedVoteStatsResponseSchema = exports.GetHistoricalAggregatedLiquidityStatsResponseSchema = exports.GetProjectStatsResponseSchema = exports.TransferProjectRewardsResponseSchema = exports.TransferProjectRewardsRequestSchema = exports.UpdateProjectRewardsResponseSchema = exports.UpdateProjectRewardsRequestSchema = exports.GetHistoricProjectTokenPricesResponseSchema = exports.GetHistoricProjectTokenPricesRequestSchema = exports.GetProjectTokenPricesResponseSchema = exports.GetProjectTokenPricesRequestSchema = exports.GetHistoricPoolTokenPricesResponseSchema = exports.GetHistoricPoolTokenPricesRequestSchema = exports.CreateGraphFromProjectConfigResponseSchema = exports.GetProjectConfigurationResponseSchema = exports.GetPoolStatsResponseSchema = exports.GetPoolStatsRequestSchema = exports.GetUserLiquidityAmountsResponseSchema = exports.GetUserLiquidityAmountsRequestSchema = exports.GetUserLiquidityEpochRewardsResponseSchema = exports.GetUserLiquidityEpochRewardsRequestSchema = exports.GetHistoricalLiquidityStatsResponseSchema = exports.GetHistoricalLiquidityStatsRequestSchema = exports.GetCompletedLiquidityEpochsResponseSchema = void 0;
exports.GetManyYieldStatsResponseSchema = exports.GetManyUserYieldsResponseSchema = exports.GetManyUserYieldsRequestSchema = exports.GetGlobalVoteInfoResponseSchema = exports.GetHistoricalVoteStatsResponseSchema = exports.GetCurrentVoteEscrowEpochInfoResponseSchema = exports.GetCompletedUserVoteEpochsPoolVotesResponseSchema = exports.GetCompletedUserVoteEpochsPoolVotesRequestSchema = exports.GetCurrentUserVoteEpochPoolVotesResponseSchema = exports.GetCurrentUserVoteEpochPoolVotesRequestSchema = void 0;
const core_contracts_ifaces_1 = require("@tutellus/core-contracts-ifaces");
const zod_1 = require("zod");
const DappRewards_1 = require("../schemas/DappRewards");
const Epoch_1 = require("../schemas/Epoch");
const ExplorePools_1 = require("../schemas/ExplorePools");
const ExploreTokens_1 = require("../schemas/ExploreTokens");
const ExploreTransactions_1 = require("../schemas/ExploreTransactions");
const GlobalVoteInfo_1 = require("../schemas/GlobalVoteInfo");
const HistoricalAggregatedLiquidityStats_1 = require("../schemas/HistoricalAggregatedLiquidityStats");
const HistoricalAggregatedVoteStats_1 = require("../schemas/HistoricalAggregatedVoteStats");
const HistoricalSyntheticStats_1 = require("../schemas/HistoricalSyntheticStats");
const HistoricalVoteStats_1 = require("../schemas/HistoricalVoteStats");
const PoolTokenPrices_1 = require("../schemas/PoolTokenPrices");
const ProjectConfig_1 = require("../schemas/ProjectConfig");
const ProjectStats_1 = require("../schemas/ProjectStats");
const ProjectTokenPrices_1 = require("../schemas/ProjectTokenPrices");
const SyntheticStats_1 = require("../schemas/SyntheticStats");
const UserEpochRewards_1 = require("../schemas/UserEpochRewards");
const UserLiquidityAmountInfo_1 = require("../schemas/UserLiquidityAmountInfo");
const UserPoolStats_1 = require("../schemas/UserPoolStats");
const UserRewards_1 = require("../schemas/UserRewards");
const UserSwapPath_1 = require("../schemas/UserSwapPath");
const UserSyntheticDeposit_1 = require("../schemas/UserSyntheticDeposit");
const UserVoteEpochPoolVote_1 = require("../schemas/UserVoteEpochPoolVote");
const UserVoteEpochRewards_1 = require("../schemas/UserVoteEpochRewards");
const VoteEpochPoolStats_1 = require("../schemas/VoteEpochPoolStats");
const VoteEscrowEpochInfo_1 = require("../schemas/VoteEscrowEpochInfo");
const Yield_1 = require("../schemas/Yield");
const DEXStats_1 = require("../schemas/DEXStats");
const ExploreTokenSummary_1 = require("../schemas/ExploreTokenSummary");
const ExplorePoolSummary_1 = require("../schemas/ExplorePoolSummary");
// //////////////////////////////////////////////////////
// APPLICATION INFO
// //////////////////////////////////////////////////////
// getApplicationInfo
exports.GetApplicationInfoResponseSchema = core_contracts_ifaces_1.ApplicationInfoSchema;
// //////////////////////////////////////////////////////
// CHARTS
// //////////////////////////////////////////////////////
exports.GetChartCommonRequestSchema = zod_1.z.object({
    currencies: zod_1.z.array(zod_1.z.nativeEnum(core_contracts_ifaces_1.CurrenciesAllowedEnum)),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime(), // ISO 8601,
    chartPointIntervalInSeconds: zod_1.z.number().int().positive(),
});
// getChartMainTokenPrice
exports.GetChartMainTokenPriceRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartMainTokenPriceResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartTVL
exports.GetChartTVLRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartTVLResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartLQCirculatingSupply
exports.GetChartLQCirculatingSupplyRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartLQCirculatingSupplyResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartLQFarming
exports.GetChartLQFarmingRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartLQFarmingResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartLQLiquidityPool
exports.GetChartLQLiquidityPoolRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartLQLiquidityPoolResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartLQStaking
exports.GetChartLQStakingRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartLQStakingResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartRWFarming
exports.GetChartRWFarmingRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartRWFarmingResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartRWFarmingAPR
exports.GetChartRWFarmingAPRRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartRWFarmingAPRResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartRWRewards
exports.GetChartRWRewardsRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartRWRewardsResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartRWStaking
exports.GetChartRWStakingRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartRWStakingResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// getChartRWStakingAPR
exports.GetChartRWStakingAPRRequestSchema = exports.GetChartCommonRequestSchema;
exports.GetChartRWStakingAPRResponseSchema = core_contracts_ifaces_1.ChartResultSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// EXPLORATION
// ////////////////////////////////////////////////////////////////////////////////////
// getExplorePools
exports.GetExplorePoolsRequestSchema = zod_1.z.object({
    pools: zod_1.z.array(zod_1.z.string()),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetExplorePoolsResponseSchema = ExplorePools_1.ExplorePoolsPaginatedListSchema;
// getExploreTokens
exports.GetExploreTokensRequestSchema = zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string()),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetExploreTokensResponseSchema = ExploreTokens_1.ExploreTokensPaginatedListSchema;
// getExploreTransactions
exports.GetExploreTransactionsRequestSchema = zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string()),
    pools: zod_1.z.array(zod_1.z.string()),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetExploreTransactionsResponseSchema = ExploreTransactions_1.ExploreTransactionsPaginatedListSchema;
// getExploreGroupedTransactions
exports.GetExploreGroupedTransactionsRequestSchema = zod_1.z.object({
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetExploreGroupedTransactionsResponseSchema = ExploreTransactions_1.ExploreGroupedTransactionsPaginatedListSchema;
// getExploreVolumeGraph
exports.GetExploreVolumeGraphRequestSchema = zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string()).optional().nullable(),
    pools: zod_1.z.array(zod_1.z.string()).optional().nullable(),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime(), // ISO 8601
    slice: zod_1.z.nativeEnum(core_contracts_ifaces_1.SliceGraphEnum),
});
exports.GetExploreVolumeGraphResponseSchema = core_contracts_ifaces_1.ChartPointListInfoSchema;
// getExploreTVLGraph
exports.GetExploreTVLGraphRequestSchema = zod_1.z.object({
    pools: zod_1.z.array(zod_1.z.string()),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime(), // ISO 8601
    slice: zod_1.z.nativeEnum(core_contracts_ifaces_1.SliceGraphEnum),
});
exports.GetExploreTVLGraphResponseSchema = core_contracts_ifaces_1.ChartPointListInfoSchema;
// getExploreTokensGraph
exports.GetExploreTokenGraphRequestSchema = zod_1.z.object({
    token: zod_1.z.string(),
    startDate: zod_1.z.string().datetime(), // ISO 8601
    endDate: zod_1.z.string().datetime(), // ISO 8601
    slice: zod_1.z.nativeEnum(core_contracts_ifaces_1.SliceGraphEnum),
});
exports.GetExploreTokenGraphResponseSchema = core_contracts_ifaces_1.ChartPointListInfoSchema;
// synchronizeTransaction
exports.SynchronizeTransactionResponseSchema = core_contracts_ifaces_1.CommonResultSchema;
// registerTransaction
exports.RegisterTransactionRequestSchema = zod_1.z
    .object({
    value: zod_1.z.number().optional().nullable(),
    uuid: zod_1.z.string().uuid(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    functionName: zod_1.z.string(),
    args: zod_1.z.unknown().optional().nullable(),
    txHash: zod_1.z.string().optional().nullable(),
    userOperationHash: zod_1.z.string().optional().nullable(),
})
    .refine((data) => {
    // Ensure that exactly one of txHash or userOperationHash is provided
    return (data.txHash && !data.userOperationHash) || (!data.txHash && data.userOperationHash);
}, {
    message: 'You must provide exactly one of txHash or userOperationHash',
    path: ['txHash', 'userOperationHash'],
})
    .refine((data) => {
    // Ensure that at least one of txHash or userOperationHash is provided
    return data.txHash || data.userOperationHash;
}, {
    message: 'You must provide at least one of txHash or userOperationHash',
    path: ['txHash', 'userOperationHash'],
});
exports.RegisterTransactionResponseSchema = core_contracts_ifaces_1.CommonResultSchema;
// updateTransaction
exports.UpdateTransactionRequestSchema = zod_1.z.object({
    txHash: zod_1.z.string(),
    userOperationHash: zod_1.z.string(),
});
exports.UpdateTransactionResponseSchema = core_contracts_ifaces_1.CommonResultSchema;
// getExploreTokenSummary
exports.GetExploreTokenSummaryRequestSchema = zod_1.z.object({
    tokenID: zod_1.z.string(),
});
exports.GetExploreTokenSummaryResponseSchema = ExploreTokenSummary_1.ExploreTokenSummarySchema;
// getExplorePoolSummary
exports.GetExplorePoolSummaryRequestSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
});
exports.GetExplorePoolSummaryResponseSchema = ExplorePoolSummary_1.ExplorePoolSummarySchema;
// ////////////////////////////////////////////////////////////////////////////////////
// LIQUIDITY
// ////////////////////////////////////////////////////////////////////////////////////
// getCurrentLiquidityEpoch
exports.GetCurrentLiquidityEpochRequestSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
exports.GetCurrentLiquidityEpochResponseSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
// getCompletedLiquidityEpochs
exports.GetCompletedLiquidityEpochsRequestSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
exports.GetCompletedLiquidityEpochsResponseSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
// getHistoricalLiquidityStats
exports.GetHistoricalLiquidityStatsRequestSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
exports.GetHistoricalLiquidityStatsResponseSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
// getUserLiquidityEpochRewards
exports.GetUserLiquidityEpochRewardsRequestSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
exports.GetUserLiquidityEpochRewardsResponseSchema = zod_1.z.object({
    dummyField: zod_1.z.string(),
});
// getUserLiquidityAmounts
exports.GetUserLiquidityAmountsRequestSchema = zod_1.z.object({
    tokenID: zod_1.z.string(),
    poolID: zod_1.z.string(),
    amount: core_contracts_ifaces_1.BigIntStringSchema,
});
exports.GetUserLiquidityAmountsResponseSchema = UserLiquidityAmountInfo_1.UserLiquidityAmountInfoSchema;
// //////////////////////////////////////////////////////
// POOLS
// //////////////////////////////////////////////////////
// getPoolStats
exports.GetPoolStatsRequestSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.string()),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetPoolStatsResponseSchema = core_contracts_ifaces_1.PoolStatsPaginatedListSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// PROJECT CONFIGURATION
// ////////////////////////////////////////////////////////////////////////////////////
// getProjectConfiguration
exports.GetProjectConfigurationResponseSchema = ProjectConfig_1.ProjectConfigSchema;
// createGraphFromProjectConfig
exports.CreateGraphFromProjectConfigResponseSchema = core_contracts_ifaces_1.CommonResultSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// PROJECT
// ////////////////////////////////////////////////////////////////////////////////////
// getHistoricPoolTokenPrices
exports.GetHistoricPoolTokenPricesRequestSchema = zod_1.z.object({
    poolID: zod_1.z.string(),
    currencies: zod_1.z.array(zod_1.z.nativeEnum(core_contracts_ifaces_1.CurrenciesAllowedEnum)),
    date: zod_1.z.string().datetime(), // ISO 8601
});
exports.GetHistoricPoolTokenPricesResponseSchema = zod_1.z.array(PoolTokenPrices_1.PoolTokenPricesSchema);
// getProjectTokenPrices
exports.GetProjectTokenPricesRequestSchema = zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string()),
    currencies: zod_1.z.array(zod_1.z.nativeEnum(core_contracts_ifaces_1.CurrenciesAllowedEnum)),
});
exports.GetProjectTokenPricesResponseSchema = zod_1.z.array(ProjectTokenPrices_1.ProjectTokenPricesSchema);
// getHistoricProjectTokenPrices
exports.GetHistoricProjectTokenPricesRequestSchema = zod_1.z.object({
    tokens: zod_1.z.array(zod_1.z.string()),
    currencies: zod_1.z.array(zod_1.z.nativeEnum(core_contracts_ifaces_1.CurrenciesAllowedEnum)),
    date: zod_1.z.string().datetime(), // ISO 8601
});
exports.GetHistoricProjectTokenPricesResponseSchema = zod_1.z.array(ProjectTokenPrices_1.ProjectTokenPricesSchema);
// updateProjectRewards
exports.UpdateProjectRewardsRequestSchema = zod_1.z.object({
    contract: zod_1.z.string(),
    newFile: zod_1.z.record(core_contracts_ifaces_1.EthereumAddressSchema, core_contracts_ifaces_1.BigIntStringSchema),
});
exports.UpdateProjectRewardsResponseSchema = DappRewards_1.DappRewardsSchema;
// transferProjectRewards
exports.TransferProjectRewardsRequestSchema = zod_1.z.object({
    contract: zod_1.z.string(),
    transfers: zod_1.z.array(zod_1.z.object({
        fromAddress: core_contracts_ifaces_1.EthereumAddressSchema,
        toAddress: core_contracts_ifaces_1.EthereumAddressSchema,
        amount: core_contracts_ifaces_1.BigIntStringSchema,
    })),
});
exports.TransferProjectRewardsResponseSchema = exports.UpdateProjectRewardsResponseSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// STATS
// ////////////////////////////////////////////////////////////////////////////////////
// getProjectStats
exports.GetProjectStatsResponseSchema = ProjectStats_1.ProjectStatsSchema;
// getHistoricalAggregatedLiquidityStats
exports.GetHistoricalAggregatedLiquidityStatsResponseSchema = HistoricalAggregatedLiquidityStats_1.HistoricalAggregatedLiquidityStatsSchema;
// getHistoricalAggregatedVoteStats
exports.GetHistoricalAggregatedVoteStatsResponseSchema = HistoricalAggregatedVoteStats_1.HistoricalAggregatedVoteStatsSchema;
// getDEXStats
exports.GetDEXStatsResponseSchema = DEXStats_1.DEXStatsSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// SWAPS
// ////////////////////////////////////////////////////////////////////////////////////
// getUserSwapPath
exports.GetUserSwapPathRequestSchema = zod_1.z
    .object({
    tokenIN: zod_1.z.string(),
    tokenOUT: zod_1.z.string(),
    amountIN: core_contracts_ifaces_1.BigIntStringSchema.optional().nullable(),
    amountOUT: core_contracts_ifaces_1.BigIntStringSchema.optional().nullable(),
})
    .refine((data) => {
    // Validación: only one property can be defined
    const { amountIN, amountOUT } = data;
    return (amountIN && !amountOUT) || (!amountIN && amountOUT);
}, {
    message: 'At least one property and only one property must be defined.',
});
exports.GetUserSwapPathResponseSchema = UserSwapPath_1.SwapPathSchema;
// //////////////////////////////////////////////////////
// SYNTHETICS
// //////////////////////////////////////////////////////
// getProjectSyntheticStats
exports.GetProjectSyntheticStatsResponseSchema = SyntheticStats_1.SyntheticStatsListSchema;
// getCompletedEpochs
exports.GetCompletedEpochsRequestSchema = zod_1.z.object({
    syntheticID: zod_1.z.string(),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
// getCurrentEpoch
exports.GetCurrentEpochRequestSchema = zod_1.z.object({
    syntheticID: zod_1.z.string(),
});
exports.GetCurrentEpochResponseSchema = Epoch_1.EpochSchema;
// getHistoricalSyntheticStats
exports.GetHistoricalSyntheticStatsRequestSchema = zod_1.z.object({
    syntheticID: zod_1.z.string(),
});
exports.GetHistoricalSyntheticStatsResponseSchema = HistoricalSyntheticStats_1.HistoricalSyntheticStatSchema;
// getUSerSyntheticDeposits
exports.GetUserSyntheticDepositsRequestSchema = zod_1.z.object({
    ownerAddress: zod_1.z.string(),
    syntheticID: zod_1.z.string(),
});
exports.GetUserSyntheticDepositsResponseSchema = UserSyntheticDeposit_1.UserSyntheticDepositListSchema;
// getUserEpochRewards
exports.GetUserEpochRewardsRequestSchema = zod_1.z.object({
    account: core_contracts_ifaces_1.EthereumAddressSchema,
    syntheticID: zod_1.z.string(),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetUserEpochRewardsResponseSchema = UserEpochRewards_1.UserEpochRewardsPaginatedListSchema;
// //////////////////////////////////////////////////////
// USERS
// //////////////////////////////////////////////////////
// getUserAllowances
exports.GetUserAllowancesRequestSchema = zod_1.z.object({
    items: zod_1.z.array(zod_1.z.object({
        owner: zod_1.z.string({ required_error: 'owner address is required' }),
        spender: zod_1.z.string({ required_error: 'spender address is required' }),
        tokenID: zod_1.z.string({ required_error: 'tokenID is required' }),
    })),
});
exports.GetUserAllowancesResponseSchema = zod_1.z.object({
    items: zod_1.z.array(core_contracts_ifaces_1.UserAllowanceSchema),
});
// getUserBalances
exports.GetUserBalancesRequestSchema = zod_1.z.object({
    address: core_contracts_ifaces_1.EthereumAddressSchema,
});
exports.GetUserBalancesResponseSchema = core_contracts_ifaces_1.UserBalancesSchema;
// getUserRewards
exports.GetUserRewardsRequestSchema = zod_1.z.object({
    address: core_contracts_ifaces_1.EthereumAddressSchema,
});
exports.GetUserRewardsResponseSchema = UserRewards_1.UserRewardsSchema;
// getUserPoolStats
exports.GetUserPoolStatsRequestSchema = zod_1.z.object({
    address: core_contracts_ifaces_1.EthereumAddressSchema,
    items: zod_1.z.array(zod_1.z.string()),
    paginationMetadata: core_contracts_ifaces_1.PaginationMetadataSchema,
});
exports.GetUserPoolStatsResponseSchema = UserPoolStats_1.UserPoolStatsPaginatedListSchema;
// //////////////////////////////////////////////////////
// VOTE
// //////////////////////////////////////////////////////
// getCurrentVoteEpochPoolStats
exports.GetCurrentVoteEpochPoolStatsResponseSchema = VoteEpochPoolStats_1.VoteEpochPoolStatsListSchema;
// getCompletedVoteEpochsPoolStats
exports.GetCompletedVoteEpochsPoolStatsRequestSchema = zod_1.z.object({
    epochID: zod_1.z.number().int().min(0),
});
exports.GetCompletedVoteEpochsPoolStatsResponseSchema = VoteEpochPoolStats_1.VoteEpochPoolStatsListSchema;
// getUserVoteEpochRewards
exports.GetUserVoteEpochRewardsRequestSchema = zod_1.z.object({
    depositID: zod_1.z.number().int().min(0),
});
exports.GetUserVoteEpochRewardsResponseSchema = UserVoteEpochRewards_1.UserVoteEpochRewardsSchema;
// getCurrentUserVoteEpochPoolVotes
exports.GetCurrentUserVoteEpochPoolVotesRequestSchema = zod_1.z.object({
    depositID: zod_1.z.number().int().min(0),
});
exports.GetCurrentUserVoteEpochPoolVotesResponseSchema = UserVoteEpochPoolVote_1.UserVoteEpochPoolVoteListSchema;
// getCompletedUserVoteEpochsPoolVotes
exports.GetCompletedUserVoteEpochsPoolVotesRequestSchema = zod_1.z.object({
    depositID: zod_1.z.number().int().min(0),
    epochID: zod_1.z.number().int().min(0),
});
exports.GetCompletedUserVoteEpochsPoolVotesResponseSchema = UserVoteEpochPoolVote_1.UserVoteEpochPoolVoteListSchema;
// getCurrentVoteEscrowEpochInfo
exports.GetCurrentVoteEscrowEpochInfoResponseSchema = VoteEscrowEpochInfo_1.VoteEscrowEpochInfoSchema;
// getHistoricalVoteStats
exports.GetHistoricalVoteStatsResponseSchema = HistoricalVoteStats_1.HistoricalVoteStatsSchema;
// getGlobalVoteInfo
exports.GetGlobalVoteInfoResponseSchema = GlobalVoteInfo_1.GlobalVoteInfoSchema;
// ////////////////////////////////////////////////////////////////////////////////////
// YIELDS
// ////////////////////////////////////////////////////////////////////////////////////
// getManyUserYields
exports.GetManyUserYieldsRequestSchema = zod_1.z.object({
    address: core_contracts_ifaces_1.EthereumAddressSchema,
});
exports.GetManyUserYieldsResponseSchema = Yield_1.UserYieldListSchema;
// getManyYieldStats
exports.GetManyYieldStatsResponseSchema = Yield_1.YieldStatsListSchema;
